<template>
	<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="505px">
		<v-card elevation="0">
			<v-card-title>
				角色&授权<v-spacer />
				<v-btn class="mx-0" icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="pa-0">
				<v-stepper v-model="e1">
					<v-stepper-header class="elevation-0">
						<v-stepper-step @click="e1 = 1" :complete="e1 > 1" step="1" class="pointer"> 创建应用角色 </v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step @click="stop" :complete="e1 > 2" step="2" class="pointer"> 角色应用授权 </v-stepper-step>
					</v-stepper-header>
					<v-divider />
					<v-stepper-items>
						<v-stepper-content step="1" class="pa-0">
							<v-card elevation="0">
								<v-card-text style="height: 560px">
									<v-form ref="entity" v-model="valid" :model="entity">
										<wtk-select label="角色等级" v-model="entity.leve" list="0:国家/2:省级/4:市级/6:区县/9:街镇/12:村社" :rules="[(v) => !!v || '角色等级不能为空']" dense outlined class="mt-1"></wtk-select>
										<!-- <wtk-select label="角色关系" v-model="entity.rsgx" list="0:并存/1:互斥" :rules="[(v) => !!v || '角色互斥不能为空']" dense outlined class="mt-1"></wtk-select> -->
										<v-text-field label="角色名称" dense outlined v-model="entity.name" :rules="[(v) => !!v || '角色名称不能为空']"></v-text-field>
										<v-text-field label="角色代码" dense outlined v-model="entity.code" :rules="[(v) => !!v || '角色代码不能为空']"></v-text-field>
										<v-textarea label="角色描述" dense outlined rows="6" v-model="entity.note" :rules="[(v) => !!v || '角色描述不能为空']"></v-textarea>
									</v-form>
									<p>
										注意：<br />
										1.系统安全设置包括应用角色和角色授权两部分；<br />
										2.角色等级决定该角色可以授权给对应级别的用户；<br />
										3.请详细填写角色名称和角色描述以便于后续维护；<br />
										4.角色管理与授权可以独立操作，授权可以暂时为空；
									</p>
								</v-card-text>
								<v-divider />
								<v-card-actions class="pr-4 pb-4">
									<v-spacer />
									<v-btn class="ml-3" text @click="close"> 取消 </v-btn>
									<v-btn class="ml-3" color="primary" @click="save" elevation="0"> 确定 </v-btn>
								</v-card-actions>
							</v-card>
						</v-stepper-content>
						<v-stepper-content step="2" class="pa-0">
							<v-card>
								<v-card-text style="height: 560px">
									<v-treeview
										hoverable
										selectable
										:items="treeItem"
										v-model="selection"
										return-object
										selection-type="independent"
										item-text="permName"
										item-key="permId"
										:class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
										class="mb-2 rounded-lg"
										style="height: 420px; overflow: auto">
										<template v-slot:prepend="{ item }">
											<v-icon :color="item.permType | dict('0:purple/1:primary/2:accent/3:secondary/4:red')"> mdi-{{ item.permType | dict("0:television-guide/1:collage/2:ballot-outline/3:card/4:tag-multiple-outline") }} </v-icon>
											{{ item.name }}
										</template>
									</v-treeview>
									<p>
										注意：<br />
										1.请根据角色的需要设置响应的权限；<br />
										2.如暂不确定角色对应的权限可先确定后续修改；<br />
										3.如需修改角色相关信息请点击顶部切换后修改；<br />
										4.授权完成后对应角色对象需要重新登录后生效；
									</p>
								</v-card-text>
								<v-divider class="mt-4" />
								<v-card-actions class="pr-4 pb-4">
									<v-spacer />
									<v-btn @click="close" elevation="0"> 取消 </v-btn>
									<v-btn class="ml-3" color="primary" @click="save2" elevation="0"> 确定 </v-btn>
								</v-card-actions>
							</v-card>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import Request from "@/commons/request";
import Message from "../../components/message";
import storage from "@/commons/storage";
import wtkSelect from "@/components/dictionary/WtkSelect";
export default {
	components: { wtkSelect },
	data: () => ({
		dialog: false,
		valid: true,
		entity: {},
		user: {},
		url: {
			save: "rbac/role/save",
		},
		e1: 1,
		treeItem: [],
		selection: [],
	}),
	mounted() {
		this.user = storage.get("_wit_acis_users");
	},
	methods: {
		add() {
			this.dialog = true;
			this.entity.aid = this.$route.query.aid;
			this.entity.id = "";
			this.e1 = 1;
		},
		edit(record) {
			this.dialog = true;
			this.e1 = 2;
			this.entity = Object.assign({}, record);
			this.tree();
		},
		stop() {
			this.entity.id ? (this.e1 = 2) : Message.toast("对不起！请先创建角色后再授权", { color: "error" });
		},
		//树形授权数据列表
		tree() {
			this.selection = [];
			if (this.entity.id) {
				Request.postForm("/rbac/role-perm/rtop", { aid: this.$route.query.aid, rid: this.entity.id }).then((res) => {
					if (res.meta.success) {
						this.selection = res.data.filter((item) => item.rolePermHas == "1");
						this.treeItem = this.getJsonTree(res.data, "0");
					} else {
						Message.toast(res.data.message, { color: "error" });
					}
				});
			} else {
				Message.toast("请先创建用户后再授权！", { color: "error" });
			}
		},
		//树形数据--递归方法 生成 json tree 数据
		getJsonTree(data, permPid) {
			const itemArr = [];
			for (const node of data) {
				if (node.permPid == permPid) {
					const newNode = {};
					newNode.permGid = node.permGid;
					newNode.permId = node.permId;
					newNode.permName = node.permName;
					newNode.permPid = node.permPid;
					newNode.permType = node.permType;
					newNode.roleId = node.roleId;
					newNode.roleName = node.roleName;
					newNode.rolePermHas = node.rolePermHas;
					newNode.children = this.getJsonTree(data, node.permId);
					itemArr.push(newNode);
				}
			}
			return itemArr;
		},
		//保存创建用户信息
		save() {
			if (this.$refs.entity.validate()) {
				Message.loading.show();
				this.entity.rsgx = "0";
				this.entity.operator = this.user.username;
				this.entity.remark = "备注";
				Request.postJson(this.url.save, this.entity).then((res) => {
					Message.loading.hide();
					if (res.meta.success) {
						this.entity = res.data;
						Message.toast("保存成功！", { color: "success" });
						this.e1 = 2;
						this.$emit("ok");
						this.tree();
					} else {
						Message.toast(res.meta.message, { color: "error" });
					}
				});
			}
		},
		//保存用户授权信息
		save2() {
			let entities = [];
			let newDate = new Date();
			Message.loading.show();
			this.entity.operator = this.user.username;
			this.selection.forEach((v) => {
				entities.push({
					rid: v.roleId,
					pid: v.permId,
					remark: v.roleName + "-" + v.permName,
					operator: this.user.username,
					operateTime: newDate,
				});
			});
			Request.postJson("/rbac/role-perm/save", { aid: this.$route.query.aid, rid: this.entity.id, entities: entities }, this.entity).then((res) => {
				Message.loading.hide();
				if (res.meta.success) {
					Message.toast("保存成功！", { color: "success" });
					this.$emit("ok");
					this.close();
				} else {
					Message.toast(res.meta.message, { color: "error" });
				}
			});
		},
		close() {
			this.e1 = 1;
			this.selection = [];
			this.$refs.entity.reset();
			this.dialog = false;
		},
	},
};
</script>

<style>
.evt_input {
	height: 100%;
}
.evt_input .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
	box-shadow: none !important;
}
</style>
